module.exports = __webpack_public_path__ + "img/diners-dark.e623a7c3.svg";